import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';
import { avatarService } from '@/services/avatar';
import useVuelidate from '@vuelidate/core';
import { minValue, required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useAvatarItemEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const { executeAction, excuteAndNotify, confirmAndRemove } = useCrudActions();

    const model = reactive({
        id: route.params.itemId,
        categoryId: null,
        categoryName: null,
        name: '',
        price: 0,
        isPublished: false,
        isNew: false,
        isDefault: false,
        isSpecial: false,
        limitSale: 0,
        totalSale: null,
        canDelete: false
    });

    const validations = {
        name: { required },
        isPublished: { required },
        isNew: { required },
        isDefault: { required },
        isSpecial: { required },
        price: { required, min: minValue(0) },
        limitSale: { required, min: minValue(0) }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = executeAction({
        request: () => avatarService.item.get(model.id),
        onSuccess: ({ data }) => Object.assign(model, data),
        onError: () => router.push({ name: ROUTE_NAME_AVATAR.CATEGORY.INDEX }),
        onFinally: async () => {
            if (model.categoryId) {
                await loadCategoryName(model.categoryId);
            }
        }
    });

    const loadCategoryName = executeAction({
        request: categoryId => avatarService.category.get(categoryId),
        onSuccess: ({ data }) => {
            model.categoryName = data.name;
        },
        onError: () => router.push({ name: ROUTE_NAME_AVATAR.CATEGORY.INDEX })
    });

    const actions = {
        update: excuteAndNotify({
            validator: v$,
            request: () =>
                avatarService.item.update(
                    model.id,
                    model.name,
                    model.price,
                    model.isPublished,
                    model.isNew,
                    model.isDefault,
                    model.isSpecial,
                    model.limitSale
                ),
            onSuccess: () =>
                router.push({
                    name: ROUTE_NAME_AVATAR.ITEM.INDEX,
                    query: { categoryId: model.categoryId }
                })
        }),
        remove: confirmAndRemove({
            request: () => avatarService.item.remove(model.id),
            onSuccess: () =>
                router.push({
                    name: ROUTE_NAME_AVATAR.ITEM.INDEX,
                    query: { categoryId: model.categoryId }
                })
        })
    };

    return { model, v$, fetch, actions };
}
